import type { SonarSalePurchase } from '@infinex/main-service-contract/v2/client/activity';

export type SonarPurchaseStatus = 'in-progress' | 'successful' | 'failed';

export function getSonarPurchaseStatus(
  p: Pick<SonarSalePurchase, 'errorMsg' | 'txHash'>
): SonarPurchaseStatus {
  if (p.errorMsg) return 'failed';
  if (p.txHash) return 'successful';
  return 'in-progress';
}
